
import { Subject, Observable } from 'rxjs';
import { EventEmitter, Injectable } from '@angular/core';

import { Deferred, getDeepFromObject } from './helpers';
import { Column } from './data-set/column';
import { Row } from './data-set/row';
import { DataSet } from './data-set/data-set';
import { DataSource } from './data-source/data-source';
import { ValidatorService } from './validator.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';


export class Grid {

  public createFormShown: boolean = false;
  public observable = new Subject<any>();
  public source: DataSource;
  public settings: any;
  public dataSet: DataSet;
  public onSelectRowSource = new Subject<any>();
  constructor(source: DataSource, settings: any, validator: ValidatorService) {
    this.setSettings(settings, validator);
    this.setSource(source);
  }

  public showActionColumn(position: string): boolean {
    return this.isCurrentActionsPosition(position) && this.isActionsVisible();
  }

  public isCurrentActionsPosition(position: string): boolean {
    return position === this.getSetting('actions.position');
  }

  public isActionsVisible(): boolean {
    return this.getSetting('actions.add') || this.getSetting('actions.edit')
      || this.getSetting('actions.delete') || this.getSetting('actions.reissue')
      || this.getSetting('actions.revoked') || this.getSetting('actions.undo')
      || this.getSetting('actions.custom').length;
  }

  public isMultiSelectVisible(): boolean {
    return this.getSetting('selectMode') === 'multi';
  }

  public getNewRow(): Row {
    return this.dataSet.newRow;
  }

  public enableCheckBox() {
    let rows = [];
    const page = this.source.getPaging().page;
    const perPage = this.source.getPaging().perPage;
    rows = this.dataSet.getRows().slice(0, perPage);
    for (const row of rows) {
      row.disableCheckBox = false;
    }
  }

  public toggleCheckBoxOnCancel() {
    let rows = [];
    const page = this.source.getPaging().page;
    const perPage = this.source.getPaging().perPage;
    rows = this.dataSet.getRows().slice(0, perPage);
    let isEditable = false;
    for (const row of rows) {
      if (row.isDeleted || row.isInEditing || row.isReissued || row.isRevoked || row.isUndo) {
        isEditable = true;
      }
    }
    if (!isEditable) {
      for (const row of rows) {
        row.disableCheckBox = false;
      }
    }

  }
  public disableCheckBoxes() {
    const page = this.source.getPaging().page;
    const perPage = this.source.getPaging().perPage;
    const rows = this.dataSet.getRows().slice(0, perPage);
    for (let row of rows) {
      row.isSelected = false;
      row.disableCheckBox = true;
    }
  }

  public toggleAddNewRecordButton(toggleOn: boolean) {
    this.settings.actions.add = toggleOn;
    this.settings.actions.edit = toggleOn;
    this.settings.actions.delete = toggleOn;
  }

  public toggleSorting(toggleOn: boolean) {
    const columns = this.dataSet.getColumns();
    for (const column of columns) {
      if (toggleOn) {
        column.isSortable = true;
      } else {
        column.isSortable = false;
      }
    }
  }

  public toggleFiltering(toggleOn: boolean) {
    const columns = this.dataSet.getColumns();
    for (const column of columns) {
      if (toggleOn) {
        column.isFilterable = true;
      } else {
        column.isFilterable = false;
      }
    }
  }

  public toggleFilteringOnCancel() {
    let rows = [];
    const page = this.source.getPaging().page;
    const perPage = this.source.getPaging().perPage;
    rows = this.dataSet.getRows().slice(0, perPage);
    let isEditable = false;
    for (const row of rows) {
      if (row.isDeleted || row.isInEditing || row.isReissued || row.isRevoked || row.isUndo) {
        isEditable = true;
      }
    }
    if (!isEditable) {
      this.toggleFiltering(true);
    }
  }

  public isGridinEditMode(): boolean {
    let rows = [];
    const perPage = this.source.getPaging().perPage;
    rows = this.dataSet.getRows().slice(0, perPage);
    let isEditable = false;
    for (const row of rows) {
      if (row.isDeleted || row.isInEditing || row.isReissued || row.isRevoked || row.isUndo) {
        isEditable = true;
      }
    }
    return isEditable;
  }

  public toggleSortingOnCancel() {
    let rows = [];
    const page = this.source.getPaging().page;
    const perPage = this.source.getPaging().perPage;
    rows = this.dataSet.getRows().slice(0, perPage);
    let isEditable = false;
    for (const row of rows) {
      if (row.isDeleted || row.isInEditing || row.isReissued || row.isRevoked || row.isUndo) {
        isEditable = true;
      }
    }
    if (!isEditable) {
      this.toggleSorting(true);
    }

  }

  public enableEditDelete(data) {
    const row = this.dataSet.findRowByData(data);
    this.dataSet.findRowByData(data).isDeleted = false;
    this.dataSet.findRowByData(data).isInEditing = false;
    this.dataSet.findRowByData(data).isReissued = false;
    this.dataSet.findRowByData(data).isRevoked = false;
    this.dataSet.findRowByData(data).isUndo = false;
    row.disableCheckBox = false;
  }

  public disableRowUpdateSuccess() {
    let rows = this.dataSet.getRows();
    for (const row of rows) {
      row.success = false;
    }
  }
  public disableRowUpdateFailure() {
    let rows = this.dataSet.getRows();
    for (const row of rows) {
      row.highlighted = false;
    }
  }

  public setSettings(settings, validator: ValidatorService) {
    this.settings = settings;
    this.dataSet = new DataSet([], this.getSetting('columns'), validator);
    if (this.source) {
      this.source.refresh();
    }
  }

  public getDataSet(): DataSet {
    return this.dataSet;
  }

  public getRowValidator(index: number, uid: number): any {
    const validator = this.dataSet.getRowValidator(index, uid);
    return validator;
  }

  public getAllRecords(): any[] {
    let rows = this.getRows();
    let records: any[] = [];
    let pushRecord = false;
    for (let row of rows) {
      let record = {
        row,
        action: '',
        validator: FormControl
      };
      if (row.isDeleted) {
        record.action = 'DELETE';
        pushRecord = true;
      } else if (row.isInEditing && !row.isNewRow) {
        record.action = 'EDIT';
        pushRecord = true;
      } else if (row.isNewRow) {
        record.action = 'ADD';
        pushRecord = true;
      } else if (row.isReissued) {
        record.action = 'N';
        pushRecord = true;
      } else if (row.isRevoked) {
        record.action = 'R';
        pushRecord = true;
      } else if (row.isUndo) {
        record.action = 'U';
        pushRecord = true;
      }
      if (pushRecord) {
        record.row = row;
        record.validator = row.getValidator();
        records.push(record);
      }
      pushRecord = false;
    }
    return records;
  }

  // Api to get list of records which have been checked from UI
  public getAllCheckedRecords(): any[] {
    let rows = this.getRows();
    let records: any[] = [];
    let pushRecord = false;
    for (let row of rows) {
      let record = {
        row,
        validator: FormControl
      };
      if (row.isSelected) {
        record.row = row;
        record.validator = row.getValidator();
        records.push(record);
      }
    }
    return records;
  }

  public setSource(source: DataSource) {
    this.source = this.prepareSource(source);

    this.source.onChanged()
      .subscribe((changes) => {
        this.processDataChange(changes);
      });
    this.source.onUpdated().subscribe((data) => {
      const changedRow = this.dataSet.findRowByData(data);
      changedRow.setData(data);
    },
      (error) => {
        //
      }
    );
  }

  public getSetting(name: string, defaultValue?: any): any {
    return getDeepFromObject(this.settings, name, defaultValue);
  }

  public getColumns(): Column[] {
    return this.dataSet.getColumns();
  }

  public getRows(): Row[] {
    return this.dataSet.getRows();
  }

  public selectRow(row: Row) {
    this.dataSet.selectRow(row);
  }

  public multipleSelectRow(row: Row) {
    this.dataSet.multipleSelectRow(row);
  }

  public onSelectRow(): Observable<any> {
    return this.onSelectRowSource.asObservable();
  }

  public edit(row: Row) {
    row.isInEditing = true;
  }

  public create(row: Row, confirmEmitter: EventEmitter<any>, position?: any) {
    // adding isNewRow attribute in data Set to identify which are the new rows
    let newData = {
      isNewRow: true
    };
    this.source.insert(position, newData);
  }

  public save(row: Row, confirmEmitter: EventEmitter<any>) {

    const deferred = new Deferred();
    deferred.promise.then((newData) => {
      newData = newData ? newData : row.getNewData();
      if (deferred.resolve.skipEdit) {
        row.isInEditing = false;
      } else {
        this.source.update(row.getData(), newData).then(() => {
          row.isInEditing = false;
          this.dataSet.addInsertedRowValidator();
        });
      }
    }).catch((err) => {
      // doing nothing
    });

    if (this.getSetting('edit.confirmSave')) {
      confirmEmitter.emit({
        data: row.getData(),
        newData: row.getNewData(),
        source: this.source,
        confirm: deferred,
        validator: this.dataSet.newRowValidator,
      });
    }
  }
  public deleteNewRow(data: any, index: any) {
    let row = this.dataSet.findRowByData(data);
    if (row.isNewRow) {
      let perPage = this.source.getPaging().perPage;
      const rows = this.dataSet.getRows().slice(0, perPage);
      this.source.removeNewRow(row.getData()).then(() => {
        // removing the corresponding validator after row is removed
        let validators = this.dataSet.getValidators();
        validators = validators.filter((el) => el.controls['uid'].value !== row.getData()['uid']);
      });
    }
  }
  public findDeletedIndex(oldRows: any[], newRows: any[]): number {
    let deletedIndex;
    let index = 0;
    let found = false;
    while (index < newRows.length) {
      if (newRows[index].data !== oldRows[index].data) {
        deletedIndex = index;
        found = true;
        break;
      } else {
        index++;
      }
    }
    if (!found) {
      deletedIndex = oldRows.length - 1;
    }
    return deletedIndex;
  }

  public deleteRow(data: any) {
    let perPage = this.source.getPaging().perPage;
    let row = this.dataSet.findRowByData(data);
    let test = this.getRows();
    const rows = this.dataSet.getRows().slice(0, perPage);
    return this.source.remove(row.getData()).then(() => {
      // removing the corresponding validator after row is removed
      let validators = this.dataSet.getValidators();
      validators = validators.filter((el) => el.controls['uid'].value !== row.getData()['uid']);
      this.observable.next('');
    });
  }

  public deleteNewRows() {
    let rows = this.getRows();
    for (const row of rows) {
      if (row.isNewRow) {
        this.source.removeNewRow(row.getData());
      }
    }
  }

  public delete(row: Row, confirmEmitter: EventEmitter<any>) {

    const deferred = new Deferred();
    deferred.promise.then(() => {
      if (this.getSetting('mode') !== 'custom') {
        this.source.remove(row.getData());
        this.dataSet.editRowValidators = this.dataSet.editRowValidators.splice(row.index, 1);
      }
    }).catch((err) => {
      // doing nothing
    });

    if (this.getSetting('delete.confirmDelete')) {
      confirmEmitter.emit({
        data: row.getData(),
        source: this.source,
        confirm: deferred,
      });
    } else {
      deferred.resolve();
    }
  }
  public isEquivalent(a, b) {
    // Create arrays of property names
    let aProps = Object.getOwnPropertyNames(a);
    let bProps = Object.getOwnPropertyNames(b);

    // If number of properties is different,
    // objects are not equivalent
    if (aProps.length !== bProps.length) {
      return false;
    }

    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < aProps.length; i++) {
      let propName = aProps[i];

      // If values of same property are not equal,
      // objects are not equivalent
      if (a[propName] !== b[propName]) {
        return false;
      }
    }

    // If we made it this far, objects
    // are considered equivalent
    return true;
  }

  public processDataChange(changes: any) {
    let event = changes;
    let index = 0;
    let perPage = this.source.getPaging().perPage;
    if (this.shouldProcessChange(changes)) {
      const rows = this.dataSet.getRows().slice(0, perPage);
      let validators = Object.assign({}, this.dataSet.editRowValidators);
      this.dataSet.setData(changes['elements'], changes['action'], changes['newRow'], changes['newRowRemoved']);
      const newRows = this.dataSet.getRows().slice(0, perPage);
      if (['remove'].indexOf(changes['action']) !== -1) {
        // restore old status of rows because when data set changes new rows are created
        // from scratch and we lose the old status,
        // hence copying the old status into newly created rows.
        for (index = 0; index < (perPage); index++) {
          if (newRows[index]) {
            let oldIndex = rows.findIndex((row) => {
              if (newRows[index].data.uid === row.data.uid) {
                return true;
              }
            });
            // restoring status of old validators into new ones
            if (oldIndex !== -1) {
              for (const key of Object.keys(validators[oldIndex].controls)) {
                if (validators[oldIndex].controls[key].disabled) {
                  newRows[index].getValidator().controls[key].disable();
                }
              }
              newRows[index].isDeleted = rows[oldIndex].isDeleted;
              newRows[index].isInEditing = rows[oldIndex].isInEditing;
              newRows[index].isReissued = rows[oldIndex].isReissued;
              newRows[index].isRevoked = rows[oldIndex].isRevoked;
              newRows[index].isUndo = rows[oldIndex].isUndo;
              newRows[index].isSelected = rows[oldIndex].isSelected;
              newRows[index].disableCheckBox = rows[oldIndex].disableCheckBox;
              newRows[index].isNewRow = rows[oldIndex].isNewRow;
              newRows[index].highlighted = rows[oldIndex].highlighted;
              newRows[index].success = rows[oldIndex].success;
              if (newRows[index].isNewRow) {
                newRows[index].isInEditing = true;
              }
            }
          }
        }
      }

      if (['prepend', 'append'].indexOf(changes['action']) !== -1) {
        if ((newRows.length > 0) && (rows.length > 0)) {
          // restore old status of rows because when data set changes new rows are created
          // from scratch and we lose the old status,
          // hence copying the old status into newly created rows.
          while (index < (perPage - 1)) {
            if (newRows[index + 1]) {
              let oldIndex = rows.findIndex((row) => {
                if (newRows[index + 1].data.uid === row.data.uid) {
                  return true;
                }
              });
              if (newRows[index + 1].isNewRow) {
                newRows[index + 1].isInEditing = true;
              }
              if (oldIndex !== -1) {
                // restoring  status of old validators into new ones
                for (const key of Object.keys(validators[oldIndex].controls)) {
                  if (validators[oldIndex].controls[key].disabled) {
                    newRows[index + 1].getValidator().controls[key].disable();
                  }
                }
                newRows[index + 1].isDeleted = rows[oldIndex].isDeleted;
                newRows[index + 1].isInEditing = rows[oldIndex].isInEditing;
                newRows[index + 1].isNewRow = rows[oldIndex].isNewRow;
                newRows[index + 1].isReissued = rows[oldIndex].isReissued;
                newRows[index + 1].isRevoked = rows[oldIndex].isRevoked;
                newRows[index + 1].isUndo = rows[oldIndex].isUndo;
                newRows[index + 1].isSelected = rows[oldIndex].isSelected;
                newRows[index + 1].disableCheckBox = rows[oldIndex].disableCheckBox;
                newRows[index + 1].highlighted = rows[oldIndex].highlighted;
                newRows[index + 1].success = rows[oldIndex].success;
              }
              index++;
            } else {
              break;
            }
          }
          newRows[0].isInEditing = true;
          newRows[0].isNewRow = true;
          newRows[0].disableCheckBox = true;
          newRows[0].isSelected = false;
        }

        if ((newRows.length > 0) && (rows.length === 0)) {
          newRows[0].isInEditing = true;
          newRows[0].isNewRow = true;
          newRows[0].disableCheckBox = true;
          newRows[0].isSelected = false;
        }
      }

      if (this.getSetting('selectMode') !== 'multi') {
        const row = this.determineRowToSelect(changes);
        if (row) {
          this.onSelectRowSource.next(newRows[0]);
        }
      }
    }
  }

  public shouldProcessChange(changes: any): boolean {
    if (['filter', 'sort', 'page', 'remove',
      'refresh', 'load', 'paging'].indexOf(changes['action']) !== -1) {
      return true;
    } else if (['prepend', 'append'].indexOf(changes['action']) !== -1) {
      return true;
    }
    return false;
  }

  // TODO: move to selectable? Separate directive
  public determineRowToSelect(changes: any): Row {
    if (['load', 'page', 'filter', 'sort', 'refresh'].indexOf(changes['action']) !== -1) {
      return this.dataSet.select();
    }
    if (changes['action'] === 'remove') {
      if (changes['elements'].length === 0) {
        // we have to store which one to select as the data will be reloaded
        this.dataSet.willSelectLastRow();
      } else {
        return this.dataSet.selectPreviousRow();
      }
    }
    if (changes['action'] === 'append') {
      // we have to store which one to select as the data will be reloaded
      this.dataSet.willSelectLastRow();
    }
    if (changes['action'] === 'add') {
      return this.dataSet.selectFirstRow();
    }
    if (changes['action'] === 'update') {
      return this.dataSet.selectFirstRow();
    }
    if (changes['action'] === 'prepend') {
      // we have to store which one to select as the data will be reloaded
      this.dataSet.willSelectFirstRow();
    }
    return null;
  }

  public prepareSource(source: any): DataSource {
    const initialSource: any = this.getInitialSort();
    if (initialSource && initialSource['field'] && initialSource['direction']) {
      source.setSort([initialSource], false);
    }
    if (this.getSetting('pager.display') === true) {
      source.setPaging(1, this.getSetting('pager.perPage'), false);
    }

    source.refresh();
    return source;
  }

  public getInitialSort() {
    const sortConf: any = {};
    this.getColumns().forEach((column: Column) => {
      if (column.isSortable && column.defaultSortDirection) {
        sortConf['field'] = column.id;
        sortConf['direction'] = column.defaultSortDirection;
        sortConf['compare'] = column.getCompareFunction();
      }
    });
    return sortConf;
  }

  public getSelectedRows(): any[] {
    return this.dataSet.getRows()
      .filter((r) => r.isSelected);
  }

  public selectAllRows(status: any) {
    this.dataSet.getRows()
      .forEach((r) => {
        if (r.isEditable) {
          r.isSelected = status;
        }
      });
  }

  public getFirstRow(): Row {
    return this.dataSet.getFirstRow();
  }

  public getLastRow(): Row {
    return this.dataSet.getLastRow();
  }

}
